import { emailConfiguration } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IEmailConfiguration, IEmailConfigurationData } from "../../models/master/email";
import { IDropdownData } from "../../models/ICommon";

export default new (class EmailConfigurationService {
  public getEmailConfiguration = async (id: number): Promise<IApiResponse<IEmailConfiguration>> => {
    try {
      let endPoint = urlBinder(emailConfiguration.GET_EMAIL_CONFIGURATION, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IEmailConfiguration>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IEmailConfiguration>;
      } else {
        throw error;
      }
    }
  };

  public getEmailConfigurations = async (collegeId?: number): Promise<IApiResponse<Array<IEmailConfigurationData>>> => {
    try {
      let endPoint = urlBinder(emailConfiguration.GET_ALL_EMAIL_CONFIGURATIONS, [collegeId]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IEmailConfigurationData>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IEmailConfigurationData>>;
      } else {
        throw error;
      }
    }
  };

  public createEmailConfiguration = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = emailConfiguration.CREATE_EMAIL_CONFIGURATION;
      const response = await APIService.post(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateEmailConfiguration = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(emailConfiguration.UPDATE_EMAIL_CONFIGURATION, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteEmailConfiguration = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(emailConfiguration.DELETE_EMAIL_CONFIGURATION, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
  public getEmailBlockUserTypes = async (emailBlockId?: number): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = urlBinder(emailConfiguration.GET_EMAIL_BLOCK_USERTYPES, [`${emailBlockId}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };

  public getEmailBlocks = async (): Promise<IApiResponse<IDropdownData[]>> => {
    try {
      let endPoint = emailConfiguration.GET_EMAIL_BLOCK
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IDropdownData[]>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IDropdownData[]>;
      } else {
        throw error;
      }
    }
  };
})();
